import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {ReactComponent as ArrowUp} from "assets/img/arrow-up.svg";
import {ReactComponent as ArrowDown} from "assets/img/arrow-down.svg";

import SidebarItem from "../../SidebarItem";

SidebarNavMenu.propTypes = {
    to: PropTypes.string,
    icon: PropTypes.any,
    content: PropTypes.any,
    noEndAdornment: PropTypes.bool,
    open: PropTypes.bool,
    selected: PropTypes.bool,
    onClick: PropTypes.func
};

function SidebarNavMenu({
    to,
    icon = null,
    content = null,
    noEndAdornment = false,
    onClick = () => {},
    open = false,
    selected = false,
    ...props
}) {
    const [showChildren, setShowChildren] = useState(open);

    const endAdornment = noEndAdornment ? null: (showChildren ? <ArrowUp /> : <ArrowDown />)

    useEffect(() => {
        setShowChildren(open)
    }, [open])

    return (
        <div
            style={{
                display: 'flex',
                flexDirection:'column'
            }}
        >
            <SidebarItem
                to={to}
                selected={selected}
                icon={icon}
                isTopLevel={true}
                endAdornment={endAdornment}
                onClick={() => {
                    setShowChildren(!showChildren)
                    onClick();
                }}
            >
                {content}
            </SidebarItem>
            {showChildren && props.children}
        </div>
    );
}

export default SidebarNavMenu;
